export enum ConnectAttributes {
    SurveySyncTimestamp = '#FieldDataViewer.SurveySyncTimestamp'
}
